import React from "react";
import * as shape from "d3-shape";
import * as scale from "d3-scale";

const getColor = status => {
  switch (status) {
    case "high":
      return "#F8D1D2";
    case "low":
      return "#DDEEE0";
    default:
      return "#FFFFFF";
  }
};

const Ranges = ({ ranges, x, y, x0, x1 }) => {
  return (
    <g>
      {ranges.map((item, idx) => {
        const { range: [start, end], status } = item;
        return (
          <rect
            key={`range${idx}`}
            fill={getColor(status)}
            x={x(x0)}
            y={y(end)}
            width={x(x1) - x(x0)}
            height={y(start) - y(end)}
          />
        );
      })}
    </g>
  );
};

export default Ranges;



// WEBPACK FOOTER //
// ./components/employee/wellness/graph/ranges.js